<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-form>
      <v-card-text>
        <v-card-title>
          <v-icon
            size="26"
            class="text--primary me-3"
          >
            {{ icons.mdiMapMarker }}
          </v-icon>
          <span>Endereço</span>
        </v-card-title>

        <v-row class="mt-3">
          <v-col
            md="2"
            cols="12"
          >
            <v-text-field
              v-model="cep"
              v-mask="'#####-###'"
              outlined
              dense
              label="CEP"
              :rules="[erro ? validators.cepRequired : validators.required]"
            >
            </v-text-field>
          </v-col>

          <v-col
            md="4"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.endereco.tipoLogradouro"
              outlined
              dense
              label="Tipo Logradouro"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            sm="8"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.endereco.logradouro"
              outlined
              dense
              label="Nome do Logradouro"
            ></v-text-field>
          </v-col>

          <v-col
            md="2"
            sm="4"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.endereco.numero"
              outlined
              dense
              label="Número"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.endereco.complemento"
              outlined
              dense
              label="Complemento"
            ></v-text-field>
          </v-col>

          <v-col
            md="6"
            sm="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.endereco.bairro"
              outlined
              dense
              label="Bairro"
            ></v-text-field>
          </v-col>

          <v-col
            md="4"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.endereco.cidade"
              outlined
              dense
              label="Cidade"
            ></v-text-field>
          </v-col>

          <v-col
            md="2"
            cols="12"
          >
            <v-select
              v-model="accountDataLocale.endereco.estado"
              outlined
              dense
              label="Estado"
              :items="estados"
            ></v-select>
          </v-col>

          <v-col
            md="6"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.endereco.referencia"
              outlined
              dense
              label="Referência"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-card-title>
              <v-icon
                size="26"
                class="text--primary me-3"
              >
                {{ icons.mdiCellphone }}
              </v-icon>
              <span>Telefones</span>
            </v-card-title>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-select
              v-model="tipo"
              dense
              outlined
              label="Tipo"
              :items="tiposDeNumero"
              :rules="[validators.select]"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-if="tipo === 'Fixo'"
              v-model="numero"
              v-mask="'(##) ####-####'"
              outlined
              dense
              label="Fixo"
              :rules="[validators.isisTelefoneFixoValidoValido]"
            ></v-text-field>

            <v-text-field
              v-else
              v-model="numero"
              v-mask="'(##) #####-####'"
              outlined
              dense
              label="Número"
              :rules="[validators.isTelefoneCelularValido]"
            ></v-text-field>
          </v-col>

          <v-col
            v-if="tipo === 'Fixo'"
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="ramal"
              outlined
              dense
              label="Ramal"
            ></v-text-field>
          </v-col>

          <v-checkbox
            v-if="tipo === 'CELULAR'"
            v-model="tipoContato"
            class="mx-2"
            value="WhatsApp"
            label="WhatsApp"
          ></v-checkbox>

          <v-checkbox
            v-if="tipo === 'CELULAR'"
            v-model="tipoContato"
            value="Telegram"
            label="Telegram"
            :rules="[validators.required]"
          ></v-checkbox>

          <v-col
            cols="12"
            md="2"
          >
            <v-card-text>
              <v-btn
                color="primary"
                @click="save"
              >
                Criar
              </v-btn>
            </v-card-text>
          </v-col>

          <v-col cols="12">
            <table-telefone v-model="accountDataLocale.telefones"></table-telefone>
          </v-col>
        </v-row>
      </v-card-text>

      <v-col cols="12">
        <v-btn
          v-if="acessoPut"
          color="primary"
          class="me-3 mt-4"
          @click="update"
        >
          <v-progress-circular
            v-if="loading"
            class="mx-6"
            indeterminate
            color="secundary"
          ></v-progress-circular>
          <span v-else>Salvar alterações</span>
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class="me-3 mt-4"
          disabled
        >
          Salvar alterações
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          class="mt-4"
          type="reset"
          @click.prevent="resetForm"
        >
          Cancelar
        </v-btn>
      </v-col>
    </v-form>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiMapMarker, mdiCellphone } from '@mdi/js'
import { alphaValidator, emailValidator, passwordValidator, required, select } from '@core/utils/validation'
import { cepRequired, isTelefoneCelularValido, isTelefoneFixoValido } from '@/utils/validation'
import TableTelefone from '@/components/tables/TableTelefone.vue'
import ColaboradorService from '@/services/modules/ColaboradorService'
import ViaCepService from '@/services/modules/ViaCepService'

export default {
  components: {
    TableTelefone,
  },

  props: {
    infoData: {
      type: Object,
      default: () => {},
    },
    cep: {
      type: String,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
      numero: '',
      tipo: '',
      ramal: '',
      tipoContato: '',
      data: [],
      erro: false,
    }
  },

  watch: {
    cep() {
      if (this.cep.length === 8 || this.cep.length === 9) {
        this.getCorreio()
      }
    },
  },

  beforeMount() {
    if (!this.accountDataLocale.endereco) {
      this.accountDataLocale.endereco = {
        bairro: '',
        numero: '',
        tipoLogradouro: '',
        logradouro: '',
        complemento: '',
        referencia: '',
        cidade: '',
        estado: '',
        cep: '',
      }
    }
    if (!this.accountDataLocale.telefones) {
      this.accountDataLocale.telefones = []
    }
  },

  methods: {
    async getCorreio() {
      const data = await ViaCepService.getEnderecoByCep(this.cep)

      this.data = data
      this.erro = data.erro

      if (this.data.cep) {
        this.accountDataLocale.endereco.cep = this.data.cep
        this.accountDataLocale.endereco.bairro = this.data.bairro
        this.accountDataLocale.endereco.logradouro = this.data.logradouro
        this.accountDataLocale.endereco.cidade = this.data.localidade
        this.accountDataLocale.endereco.estado = this.data.uf
      }
    },

    save() {
      if (!this.numero || !this.tipo) {
        this.$toast.error('Preencha o número e o tipo de telefone')
      } else if (this.accountDataLocale.telefones.some(tel => tel.numero === this.numero.trim())) {
        this.$toast.error('Número já cadastrado')
      } else {
        this.accountDataLocale.telefones.push({
          numero: this.numero,
          ramal: this.ramal,
          tipo: this.tipo,
          tipoContato: this.tipoContato,
        })
        this.tipo = ''
        this.numero = ''
        this.ramal = ''
        this.tipoContato = ''
      }
    },

    update() {
      this.accountDataLocale.id = null
      this.loading = true

      ColaboradorService
        .update(this.accountDataLocale)
        .then(() => {
          this.$emit('handleStepInfo')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  setup(props) {
    const estados = [
      'AC',
      'AL',
      'AP',
      'AM',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MT',
      'MS',
      'MG',
      'PA',
      'PB',
      'PR',
      'PE',
      'PI',
      'RJ',
      'RN',
      'RS',
      'RO',
      'RR',
      'SC',
      'SP',
      'SE',
      'TO',
    ]
    const tiposDeNumero = ['CELULAR', 'FIXO']
    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.infoData)))

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.infoData))
    }

    return {
      estados,
      tiposDeNumero,
      accountDataLocale,
      resetForm,
      validators: {
        cepRequired,
        required,
        emailValidator,
        passwordValidator,
        alphaValidator,
        select,
        isTelefoneCelularValido,
        isTelefoneFixoValido,
      },
      icons: {
        mdiMapMarker,
        mdiCellphone,
      },
    }
  },
}
</script>
